"use strict";
/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2018 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartData = void 0;
const CartMessage_1 = require("./CartMessage");
const CartPosition_1 = require("./CartPosition");
const CartRebateVoucher_1 = require("./CartRebateVoucher");
const CartValue_1 = require("./CartValue");
class CartData {
    constructor(rawData) {
        this.cartId = rawData.cartId;
        this.countryCode = rawData.countryCode;
        this.currencyCode = rawData.currencyCode;
        this.isUsingPoints = rawData.isUsingPoints;
        this.isValid = rawData.isValid;
        this.isNet = rawData.isNet;
        this.vatNumber = rawData.vatNumber;
        this.isCorporateCustomer = rawData.isCorporateCustomer;
        this.isCompleted = rawData.isCompleted;
        this.promotion = rawData.promotion;
        this.visitorId = rawData.visitorId;
        this.messages = [];
        this.logisticsTypeId = rawData.logisticsTypeId;
        this.paymentInformation = rawData.paymentInformation;
        this.shippingInformation = rawData.shippingInformation;
        if (rawData.messages) {
            for (const messageData of rawData.messages) {
                this.messages.push(new CartMessage_1.CartMessage(messageData));
            }
        }
        this.positions = [];
        for (const positionData of rawData.positions) {
            this.positions.push(new CartPosition_1.CartPosition(positionData));
        }
        this.rebates = [];
        if (rawData.rebates) {
            for (const rebateData of rawData.rebates) {
                this.rebates.push(new CartRebateVoucher_1.CartRebateVoucher(rebateData));
            }
        }
        this.value = new CartValue_1.CartValue(rawData.value);
    }
}
exports.CartData = CartData;
